export const bottomBar = {
  position: 'sticky',
  left: 0,
  bottom: 0,
  display: 'flex',
  justifyContent: 'space-between',
  marginLeft: '-30px',
  width: 'calc(100% + 30px)',
  padding: '24px 58px',
  borderTop: '1px solid var(--grey200)',
  background: 'var(--white)',
  opacity: 0,
  visibility: 'hidden',
  boxShadow: '0px -4px 20px 0px #0000001a',
  transition: '0.3s',
  height: 'fit-content',
  marginTop: 'auto',

  '&.bar-opened': {
    opacity: 1,
    visibility: 'visible',
  },

  '@media (max-width: 1024px)': {
    position: 'fixed',
    marginLeft: '0',
    width: '100%',
  },

  '@media (max-width: 768px)': {
    padding: '24px 16px',
  },
};

export const actionBtns = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
};

export const cancelBtn = {
  fontWeight: 500,
  fontSize: '15px',
  textDecoration: 'underline',
  textTransform: 'capitalize',
};

export const actionBtn = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  fontWeight: 500,
  fontSize: '15px',
  padding: '4px 16px',
  borderRadius: '20px',
  textTransform: 'capitalize',
  border: '1px solid var(--textMain)',

  '&.delete-btn': {
    color: 'var(--darkRed)',
    border: '1px solid var(--darkRed)',
  },

  '@media (max-width: 768px)': {
    padding: '4px',
    height: '32px',
    width: '32px',
  },
};
